import type {
  AddressServiceAddressValidationResponse,
  AddressServiceAddressValidationRequest,
} from '@shipium-corp/shipium-ts-types';
import GatewayAxiosClient from '~/store/services/GatewayAxiosClient';

interface ValidatedAddressMetadata {
  latitude: number;
  longitude: number;
  timeZoneId: string;
  validated?: boolean;
  daylightSavings?: boolean;
}

export async function validate(payload: AddressServiceAddressValidationRequest) {
  const response = await GatewayAxiosClient.post<AddressServiceAddressValidationResponse>(
    '/address-proxy/api/v1/address/validate',
    payload,
  );

  return response.data;
}

export async function validateMetadata(payload: { postalCode: string; countryCode: string }) {
  const response = await GatewayAxiosClient.post<ValidatedAddressMetadata>(
    '/address-proxy/api/v1/address/validate/metadata',
    payload,
  );

  return response.data;
}
